/**
 * Türkçe karakter desteğiyle initial üretici (BRANDBOOK §6.16 + C3C).
 * KVKK kararı: foto upload yok, sadece initials → Avatar component'i kullanır.
 *
 * Algoritma:
 *   - 2+ kelime → ilk + son kelimenin baş harfi (`"Halil Enes Dağhan" → "HD"`)
 *   - 1 kelime  → ilk 2 harf (`"Mert" → "ME"`)
 *   - boş       → `"?"`
 *
 * Türkçe uppercase locale-aware: `İstanbul → İS`, `iyzico → İY` (Türkçe "i" → "İ").
 */
export function turkishInitials(name: string | null | undefined): string {
  if (!name) return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';

  if (parts.length === 1) {
    const word = parts[0];
    if (word.length === 1) return word.toLocaleUpperCase('tr-TR');
    return (word[0] + word[1]).toLocaleUpperCase('tr-TR');
  }

  const first = parts[0][0] ?? '';
  const last = parts[parts.length - 1][0] ?? '';
  return (first + last).toLocaleUpperCase('tr-TR');
}
